<script>
import { useRouter } from 'vue-router'

export default {
  name: 'CustomToast',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    text: {
      type: String,
      required: false,
      default: ''
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    route: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup (props) {
    const router = useRouter()
    const handleToastClick = () => {
      if (props.route) {
        router.push({ name: props.route })
      }
    }
    return {
      handleToastClick
    }
  }
}
</script>

<template>
  <div @click="handleToastClick" class="custom-toast__content">
    <div class="custom-toast__icon">
      <img
        v-if="icon"
        :src="require(`@/assets/uploads/icon/toasts/${icon}.svg`)"
        alt="" />
    </div>
    <div class="custom-toast__text">
      <p>{{ title }}</p>
      <p v-html="text"></p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.custom-toast__icon {
  img {
    min-width: 24px;
  }
}
.custom-toast__text {
  p {
    font-weight: 500;

    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
